// extracted by mini-css-extract-plugin
module.exports = {"item":"DBat","top":"DBkf","header":"DBap","time":"DBjz","link":"DBch","advMarker":"DBlx"};